import React from 'react'
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import CheckIcon from '@mui/icons-material/Check';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Button from "@mui/material/Button";
import './Styles/StepperStyle.css'
import zIndex from '@material-ui/core/styles/zIndex';
import axios from "axios";
import './Styles/StepperStyle.css'
import $ from 'jquery';
import swal from 'sweetalert';
import { useGlobalContext } from "../../../../../context";
import ApiSetting from "../../../../../Settings/ApiSettings.json";
import Cookies from "universal-cookie";


// import { useGlobalContext } from "../../../../../context";


const cookies = new Cookies();
const language = cookies.get("language") ? cookies.get("language") : "ar";
  
  
export default function StepperIncomeTaxReport({
  object,setObject,setRender,render,advanceSearch,permissionsForCurrentStage,
  setRenderCheck,renderCheck,ModeOfInsertData,storeDataOfForm,getCalculationsForAmount,
  loading,loading2,FormatingStepper,activeStep,setActiveStep,setSections,cureentStageTransactionType,
  setCurrentStageTransactionType,setPermissions,setPermissionsForCurrentStage,
  compleletStage,
  setMainTransaction,
  setCompleteStage
,getCurrentReportDataAfterUpdate}) {

  const {
    fetchData,
    setUserInfo,
  } = useGlobalContext();

  const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));
  
  const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#784af4',
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  }));
  
  function QontoStepIcon(props) {
    const { active, completed, className } = props;
  
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  
  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
  };
  
  const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 136deg, #4f5d38c4 0%, #4f5d38d9 50%, #889d66 100%);',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundImage:
          'linear-gradient( 136deg, #4f5d38c4 0%, #4f5d38d9 50%, #889d66 100%);',
      },

    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 3,
      border: 0,
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderRadius: 1,
    },
  }));
  
  const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active==true&& {
      backgroundImage:
        'linear-gradient( 136deg, #fff 0%, #fff 50%, #fff 100%);',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      outline:"1px solid white",
      outlineOffset:'5px',
      color:'#cccccc',

    }),
    ...(ownerState.active==7&& {
      backgroundImage:
        'linear-gradient( 136deg, #f00 0%, #f00 50%, #f00 100%);',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      outline:"1px solid white",
      outlineOffset:'5px',
      color:'#cccccc',

    }),
    ...(ownerState.completed==true && {
      backgroundImage:
        'linear-gradient( 136deg, #8dab7ff0 0%, #8dab7ffc 50%, #8dab7f 100%);',
        boxShadow: '0 0 0 rgba(0,0,0,.25)',
        outline:"none",
      outlineOffset:'0',
      color:'white',

    }),
    ...(ownerState.completed==7 && {
      backgroundImage:
        'linear-gradient( 136deg, #f00 0%, #f00 50%, #f00 100%);',
        boxShadow: '0 0 0 rgba(0,0,0,.25)',
        outline:"none",
      outlineOffset:'0',
      color:'white',

    }),
    cursor: 'pointer',
  //   '&:hover': {
  //     backgroundImage:
  //       'linear-gradient( 136deg, rgb(95 123 138 / 100%) 0%, rgb(68 88 99) 50%, rgb(22 30 35) 79%);',
  //  },
  }));
  
  function ColorlibStepIcon(props,get_status) {
    const { active, completed, className } = props;
    var icons={}
    // let get_status=false;
      FormatingStepper?.map((item,index)=>{
        // if(stage_name==item?.stage_name){
        //   get_status=item?.status
        // }
        console.log(item?.status);
         icons = {
          ...icons,
          [index+1]:item?.status==true?<CheckIcon/>:<FiberManualRecordIcon/>
        };
      })
   
  
    return (
      <ColorlibStepIconRoot ownerState={{ completed, active}}  className={className} >
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }
  
  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };


  const getSectionsFromRequest=(data)=>{
    let arr=[]
    let arr2=[]
    data?.list?.map((itm)=>{
           arr.push(itm?.section)
           arr2.push({per:itm?.permissions,section_id:itm?.section?.id})
    }) 
    setPermissions(arr2)
    setSections(arr)
    setCurrentStageTransactionType(data?.currentStage)
    if(permissionsForCurrentStage==true)
      setPermissionsForCurrentStage(false)
      advanceSearch()
    setRender(!render)

    setCompleteStage(data?.complete)
    setMainTransaction(data?.transaction)

    getCurrentReportDataAfterUpdate();
    
  }

  const checkAndGetDataOfStageSelected=async(dataItem)=>{
    
    let data=null;
    try{
      data=await axios({
        method: 'post',
        url: ApiSetting.apiUrl+'/income_tax_report/tapNavigate',
        data:{
          user_id:cookies.get('user_id'),
          role_id:parseInt(cookies.get('role_id'))+1,
          stage_transaction_type_id:dataItem?.stage_transaction_type_id,
          transaction_id:dataItem?.transactions_id,
          income_report_id:dataItem?.income_report_id,
          transaction_type_id: dataItem?.transaction_type_id,
          currentSelectedStage:cureentStageTransactionType?.id
        },
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          "X-localization": language,
        }
      })
      if(data){
          if(data?.data?.status==200){
            if(data?.data?.data)
              getSectionsFromRequest(data?.data?.data)
          }else if(data?.data?.status==501){
            let messages=''
                  if(data?.data?.data?.user_id){
                    data?.data?.data?.user_id?.map((mesErr)=>{
                         messages+=mesErr+'\n'
                    })
                  }
                  if(data?.data?.data?.role_id){
                    data?.data?.data?.role_id?.map((mesErr)=>{
                         messages+=mesErr+'\n'
                    })
                  }

                  if(data?.data?.data?.transaction_id){
                    data?.data?.data?.transaction_id?.map((mesErr)=>{
                         messages+=mesErr+'\n'
                    })
                  }
                  if(data?.data?.data?.stage_transaction_type_id){
                    data?.data?.data?.stage_transaction_type_id?.map((mesErr)=>{
                         messages+=mesErr+'\n'
                    })
                  }
            swal("فشل استرجاع البيانات!", `${messages}`, "warning");

          }else{
            swal("فشل استرجاع البيانات!", `${data?.data?.message}`, "warning");
          }
      }
    }catch(err){
      //  console.log(err.message);
       swal("فشل استرجاع البيانات!", `${err?.message}`, "warning");

    }
  }



 
  
  const steps = ['Select campaign settings', 'Create an ad group', 'Create an ad'];

  return (
    <Stack sx={{ width: '75%'}} spacing={4}>
  
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector  />}>
        {FormatingStepper?.map((label,index) => {
           console.log('status',label?.status_reject)
           

         return <Step key={index} sx={{color:'white'}}   onClick={()=>{
            checkAndGetDataOfStageSelected(label)
          }}>
            <StepLabel sx={{color:'white'}}   StepIconComponent={(props)=>ColorlibStepIcon({
              ...props,
              active:((cureentStageTransactionType?.id==label?.stage_transaction_type_id&&label?.status!=7  )?true:label?.status),
              completed:((cureentStageTransactionType?.id==label?.stage_transaction_type_id )?false:cureentStageTransactionType?.order_number>label?.order_number?true:label?.status),
              },label?.status)}>{label?.stage_name}</StepLabel>
                </Step>
         })}

        <div className='d-flex'> 

        {
        cureentStageTransactionType?.id==2?
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            backgroundColor: "transparent",
            paddingLeft: 10,
            paddingRight: 10,
            paddingBottom: 30,
            // position:'absolute',
            // left:0,
            zIndex:1000,

            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >

        

          <Button
            variant="contained"
            style={{
              backgroundColor: "#8eac80",
              width: "100%",
              fontSize: "18px",
              position: "relative",top:'-5px',
            }}
            onClick={()=>{
               getCalculationsForAmount(2)
            }
            }
          >
            {!loading2 ? (
              'حساب'
            ) : (
              <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>
        </div>:null
        }

        
        {
        cureentStageTransactionType?.id==2&& ModeOfInsertData=='أضافة'?
        <div
          style={{
            display: "flex",
            width: "50%",
            marginTop: 10,
            backgroundColor: "transparent",
            paddingLeft: 10,
            paddingRight: 10,
            paddingBottom: 30,
            // position:'absolute',
            // left:0,
            zIndex:1000,

            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >

        

          <Button
            variant="contained"
            style={{
              backgroundColor: "#8eac80",
              width: "100%",
              fontSize: "18px",
              position: "relative",top:'-5px',
            }}
            onClick={()=>{
              storeDataOfForm(0)
            }
            }
          >
            {!loading ? (
              'أضافة'
            ) : (
              <div className="spinner-border " role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            )}
          </Button>
        </div>:null
        }




       </div>

      </Stepper>
    </Stack>
  )
}
